module.exports = __webpack_public_path__ + "d36d1cc534700434d2a8852bb3bbe67d.svg";